import { motion } from "framer-motion";
import "../styles/NexaAccelerator/Hero.css";

export default function HeroSection() {
  return (
    <section className="Accelerator-hero-section">
      <div className="accelerator-main-overlay">
        <motion.div
          className="Accelerator-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          {" "}
          <h1 className="herosection-title">
            <span className="herosection-main-title">Nexa</span>
            <span className="herosection-subtitle"> Accelerate</span>
          </h1>
        </motion.div>
      </div>
    </section>
  );
}
